export default "__VITE_ASSET__Cz9j8LKl__"